"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorController = exports.TOPO_TOOL_LOOKUP = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var i18n_1 = require("../../i18n");
var streetview_1 = require("../../modules/streetview");
var bounding_string_1 = require("../../modules/tag.map/bounding.string");
var topological_editor_map_1 = require("../../modules/topological.editor.map");
var point_collection_cache_1 = require("../../modules/topological.editor.map/point.collection.cache");
var topological_editor_tool_1 = require("../../modules/topological.editor.tool");
var services_1 = require("../../services");
var mobx_2 = require("../../state/mobx");
var store_1 = require("../../store");
var topological_editor_collection_edit_ctrl_1 = require("./topological.editor.collection.edit.ctrl");
exports.TOPO_TOOL_LOOKUP = {
    relocatePole: topological_editor_tool_1.RelocatePoleToolController
};
var TopologicalEditorController = /** @class */ (function (_super) {
    tslib_1.__extends(TopologicalEditorController, _super);
    function TopologicalEditorController() {
        var _this = _super.call(this) || this;
        _this.disposers = [];
        _this.mapIsReady = false;
        _this.classnames = [];
        _this.map = new topological_editor_map_1.TopologicalEditorMap({
            onTagClick: function (revision) {
                _this.setSelectedCollectionRevision(revision);
                _this.setSelectedVectorId(null);
            },
            onVectorClick: function (collectionRevision, vectorId) {
                _this.setSelectedCollectionRevision(collectionRevision);
                _this.setSelectedVectorId(vectorId);
            },
            onVectorDragStart: function () { return _this.exitTool(); }
        });
        _this.streetview = new streetview_1.Streetview();
        _this.selectedCollectionRevision = null;
        _this.selectedCaptureId = null;
        _this.selectedVectorId = null;
        _this.activeTool = null;
        _this.collectionEditControllers = [];
        _this.isSaving = false;
        _this.mapIsReady = false;
        services_1.Services.Map.isReadyPromise.then(function () {
            services_1.Services.Map.map.setOptions({
                fullscreenControl: false
            });
            services_1.Services.Map.map.setStreetView(services_1.Services.Streetview.instance);
            services_1.Services.Map.map.getStreetView().setVisible(true);
            _this.boundExitTool = _this.exitTool.bind(_this);
            _this.bindReactions();
            _this.bindOnCollectionModelsUpdate();
            _this.bindOnSelectedCollectionUpdate();
            _this.centerMapOnLoad();
            _this.bindMapMoveRouteUpdate();
            _this.mapIsReady = true;
            _this.refreshOverlay();
            _this.setSelectedCollectionRevision(null);
        });
        return _this;
    }
    Object.defineProperty(TopologicalEditorController.prototype, "tag", {
        get: function () {
            if (services_1.Services.Department.current) {
                return store_1.AppStore.Tag.get(services_1.Services.Route.params.get('jobId'));
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorController.prototype, "routeCollectionUUID", {
        get: function () {
            return services_1.Services.Route.params.get('collectionUUID');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorController.prototype, "locationFromRoute", {
        get: function () {
            var str = services_1.Services.Route.params.get('location');
            if (str) {
                return bounding_string_1.BoundingString.fromString(str);
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorController.prototype, "tagSummary", {
        get: function () {
            if (this.tag) {
                return store_1.AppStore.TagSummary.get(this.tag.objectId);
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorController.prototype, "collections", {
        get: function () {
            if (this.tagSummary) {
                var revisions = this.tagSummary.revisions;
                var collections = revisions.map(function (revision) {
                    return store_1.AppStore.CollectionSummary.get(revision);
                });
                return collections;
            }
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorController.prototype, "collectionModels", {
        get: function () {
            if (this.tagSummary) {
                return this.tagSummary.revisions.map(function (revision) {
                    return store_1.AppStore.Collection.get(revision);
                });
            }
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorController.prototype, "mapViewCollections", {
        get: function () {
            var _this = this;
            if (this.tagSummary) {
                return this.tagSummary.revisions.map(function (revision) {
                    return _this.getEditCtrlByRevision(revision)
                        ? _this.getEditCtrlByRevision(revision).collectionEditState.collection
                        : store_1.AppStore.Collection.get(revision);
                });
            }
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorController.prototype, "selectedCollection", {
        get: function () {
            var _this = this;
            var result = null;
            if (this.selectedCollectionRevision) {
                var hasEdits = this.collectionEditControllers.some(function (ctrl) { return ctrl.revision === _this.selectedCollectionRevision; });
                if (hasEdits) {
                    result = this.collectionEditControllers.find(function (ctrl) { return ctrl.revision === _this.selectedCollectionRevision; }).collection;
                }
                else {
                    result = store_1.AppStore.Collection.get(this.selectedCollectionRevision);
                }
            }
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorController.prototype, "selectedCapture", {
        get: function () {
            if (this.selectedCollectionRevision) {
                var selectedCollection = store_1.AppStore.Collection.get(this.selectedCollectionRevision);
                return selectedCollection.state.getCapture(this.selectedCaptureId);
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    TopologicalEditorController.prototype.getCaptureIds = function () {
        var selectedCollectionRevision = this.selectedCollectionRevision;
        var captureIds = [];
        if (selectedCollectionRevision) {
            store_1.AppStore.Collection.get(selectedCollectionRevision).forEachField(function (field) {
                if (core_shared_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
                    var fieldCaptureIds = field.getCaptures().map(function (capture) { return capture.objectId; });
                    captureIds = captureIds.concat(fieldCaptureIds);
                }
            });
        }
        return captureIds;
    };
    Object.defineProperty(TopologicalEditorController.prototype, "selectedCollectionEdit", {
        get: function () {
            if (this.selectedCollection) {
                return this.getEditCtrlByRevision(this.selectedCollection.revision);
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorController.prototype, "hasChanges", {
        get: function () {
            return this.collectionEditControllers.some(function (ctrl) { return ctrl.collectionEditState.isDirty && ctrl.isValid; });
        },
        enumerable: false,
        configurable: true
    });
    TopologicalEditorController.prototype.setSelectedCollectionRevision = function (revision, captureId) {
        this.selectedCollectionRevision = revision;
        if (captureId) {
            this.setSelectedCaptureId(captureId);
        }
        if (this.map && this.map.overlay) {
            this.map.overlay.setSelectedCollectionRevision(revision);
        }
        if (revision) {
            var collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
            services_1.Services.Route.setParam('collectionUUID', collectionSummary.uuid, false);
        }
    };
    TopologicalEditorController.prototype.setSelectedCaptureId = function (captureId) {
        this.selectedCaptureId = captureId;
    };
    TopologicalEditorController.prototype.setSelectedVectorId = function (id) {
        this.selectedVectorId = id;
    };
    TopologicalEditorController.prototype.createEditControllerForCollection = function (collection) {
        if (this.getEditCtrlById(collection.id)) {
            this.removeEditController(collection.id);
        }
        this.collectionEditControllers.push(new topological_editor_collection_edit_ctrl_1.TopologicalEditorCollectionEditCtrl(collection, this));
    };
    TopologicalEditorController.prototype.zoomToSelectedCollection = function () {
        if (!this.selectedCollection || !this.selectedCollection.location) {
            return;
        }
        var _a = this.selectedCollection.location, latitude = _a.latitude, longitude = _a.longitude;
        var position = {
            lat: latitude,
            lng: longitude
        };
        this.map.map.setCenter(position);
        this.map.map.setZoom(20);
    };
    /**
     * Center the map on page load
     */
    TopologicalEditorController.prototype.centerMapOnLoad = function () {
        var parsedBounds = this.locationFromRoute;
        if (parsedBounds) {
            this.map.map.setCenter(new google.maps.LatLng(parsedBounds.lat, parsedBounds.lng));
            this.map.map.setZoom(parsedBounds.zoom);
        }
    };
    /**
     * Update the url when the map gets updated after `Services.Analytics.DEBOUNCE_TIME` amount of time
     */
    TopologicalEditorController.prototype.bindMapMoveRouteUpdate = function () {
        var _this = this;
        this.disposers.push((0, mobx_1.reaction)(function () {
            var _a;
            return {
                center: _this.map.overlay.bounds && ((_a = _this.map.overlay.bounds.getCenter()) === null || _a === void 0 ? void 0 : _a.toJSON()),
                zoom: _this.map.overlay.zoom
            };
        }, function (args) {
            var boundingString = bounding_string_1.BoundingString.toString(args.center, args.zoom);
            if (boundingString === '') {
                return;
            }
            services_1.Services.Route.setParam('location', boundingString);
        }, { delay: services_1.Services.Analytics.DEBOUNCE_TIME }));
    };
    TopologicalEditorController.prototype.getEditCtrlByRevision = function (revision) {
        return this.collectionEditControllers.find(function (x) { return x.revision === revision; });
    };
    TopologicalEditorController.prototype.getEditCtrlById = function (id) {
        return this.collectionEditControllers.find(function (x) { return x.id === id; });
    };
    TopologicalEditorController.prototype.removeEditController = function (id) {
        this.collectionEditControllers = this.collectionEditControllers.filter(function (x) { return x.id !== id; });
    };
    TopologicalEditorController.prototype.collectionHasChanges = function (id) {
        var collectionEditController = this.collectionEditControllers.find(function (ctrl) { return ctrl.id === id; });
        if (collectionEditController) {
            return (collectionEditController.collectionEditState.isDirty && collectionEditController.isValid);
        }
        return false;
    };
    TopologicalEditorController.prototype.bindOnSelectedCollectionUpdate = function () {
        var _this = this;
        this.disposers.push((0, mobx_1.reaction)(function () { return _this.selectedCollection; }, function () {
            _this.exitTool();
            if (_this.selectedCollection) {
                if (!_this.getEditCtrlByRevision(_this.selectedCollection.revision)) {
                    _this.createEditControllerForCollection(_this.selectedCollection);
                    _this.refreshOverlay();
                }
                if (_this.selectedCollection.location) {
                    var _a = _this.selectedCollection.location, latitude = _a.latitude, longitude = _a.longitude;
                    var collectionPosition_1 = new google.maps.LatLng(latitude, longitude);
                    var updateStreetView_1 = function (streetView, panoData) {
                        var streetViewPosition = panoData.location.latLng;
                        streetView.setPosition(streetViewPosition);
                        streetView.setPano(panoData.location.pano);
                        var heading = google.maps.geometry.spherical.computeHeading(streetViewPosition, collectionPosition_1);
                        streetView.setPov({
                            heading: heading,
                            pitch: 15
                        });
                    };
                    services_1.Services.Map.isReadyPromise.then(function () {
                        var streetViewService = services_1.Services.Streetview.streetViewService;
                        streetViewService.getPanorama({ location: collectionPosition_1, source: google.maps.StreetViewSource.OUTDOOR }, function (panoData, status) {
                            if (status === google.maps.StreetViewStatus.OK) {
                                updateStreetView_1(services_1.Services.Map.map.getStreetView(), panoData);
                            }
                        });
                    });
                }
            }
        }));
    };
    TopologicalEditorController.prototype.bindOnCollectionModelsUpdate = function () {
        var _this = this;
        this.disposers.push((0, mobx_1.reaction)(function () { return _this.collectionModels; }, function () {
            _this.refreshOverlay();
        }));
    };
    Object.defineProperty(TopologicalEditorController.prototype, "contentClassNames", {
        get: function () {
            return this.classnames.join(' ');
        },
        enumerable: false,
        configurable: true
    });
    TopologicalEditorController.prototype.useTool = function (toolname) {
        var Tool = exports.TOPO_TOOL_LOOKUP[toolname];
        // If this tool is already active then toggle it off
        if (this.activeTool instanceof Tool) {
            this.exitTool();
        }
        else {
            this.instantiateTool(toolname);
        }
    };
    TopologicalEditorController.prototype.instantiateTool = function (toolname) {
        this.eventContext = services_1.Services.Input.getContext();
        if (!exports.TOPO_TOOL_LOOKUP[toolname]) {
            throw new Error("Could not instantiate Topological Editor tool ".concat(toolname, " because it does not exist"));
        }
        this.activeTool = new exports.TOPO_TOOL_LOOKUP[toolname](this);
        this.eventContext.on(this.eventContext.Code.Escape, this.boundExitTool);
        this.map.overlay.setHideTitles(true);
    };
    TopologicalEditorController.prototype.exitTool = function () {
        if (this.eventContext) {
            this.eventContext.destroy();
        }
        if (this.activeTool) {
            this.activeTool.destroy();
            this.activeTool = null;
            this.map.overlay.setHideTitles(false);
        }
    };
    TopologicalEditorController.prototype.refreshOverlay = function () {
        if (typeof this.map.overlay !== 'undefined') {
            this.map.overlay.setCollections(this.mapViewCollections);
        }
    };
    TopologicalEditorController.prototype.destroy = function () {
        this.exitTool();
        this.map.overlay.onRemove();
        _super.prototype.destroy.call(this);
    };
    TopologicalEditorController.prototype.batchSave = function () {
        var _this = this;
        this.setSaving(true);
        Promise.all(this.collectionEditControllers.map(function (controller) { return controller.batchSaveChanges(); }))
            .then(function (result) {
            _this.setSaving(false);
            notification_service_1.NotificationService.success({
                key: (0, i18n_1.Translate)(i18n_1.T.TOPO_SUCCESS_SAVE_JOB, { amount: result.filter(Boolean).length })
            });
        })
            .catch(function (e) {
            services_1.Services.Log.Logger.error(e, 'TE: Error saving job');
            notification_service_1.NotificationService.error({
                key: i18n_1.T.COLLECTION_EDIT_SAVE_ERROR
            });
            _this.setSaving(false);
        });
    };
    TopologicalEditorController.prototype.setSaving = function (save) {
        this.isSaving = save;
    };
    /**
     * Loops through all available collections and spans and snaps any straggler spans to its nearest collection within a 3m radius
     */
    TopologicalEditorController.prototype.bulkSnap = function () {
        var _this = this;
        var spans = [];
        // Collect all the spans
        this.mapViewCollections.forEach(function (collection) {
            var summary = store_1.AppStore.CollectionSummary.get(collection.revision);
            // Filter out non spans & spans that are already linked to another collection
            var vectors = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionVectors(summary.revision);
            spans.push.apply(spans, vectors.filter(function (x) { return x.field.id.includes('spanLength') && !x.field.isCollectionLink(); }));
        });
        var pendingSnaps = [];
        spans.forEach(function (span) {
            var collectionCandidate = { collectionId: null, distance: 3 }; // TODO: PD-966
            // TODO: we can condense this down to an Array.map & Array.sort in the future
            for (var _i = 0, _a = _this.mapViewCollections; _i < _a.length; _i++) {
                var point = _a[_i];
                // Skip the collection the span originates from it
                //   or if a location is not found
                if (point.revision === span.field.collection.revision || !point.location) {
                    continue;
                }
                // Get the distance between the span target and the current point
                var distance = core_shared_1.IkeGeodesic.getDistance(span.target, {
                    latitude: point.location.latitude,
                    longitude: point.location.longitude,
                    altitude: span.target.altitude
                    /*
                    We use the span target altitude here instead of the point altitude because often the differences in altitude are upwards of 20 meters
                    and if we were to use it, the spans would never snap.

                    Also, fun fact, IkeGeodesic.getDistance never actually uses altitude even though it is a required parameter
                    */
                });
                // If the current point has a closer distance than the active candidate
                if (distance < collectionCandidate.distance) {
                    collectionCandidate.collectionId = point.id;
                    collectionCandidate.distance = distance;
                }
            }
            // Add the span and the to-be linked collection ID
            if (collectionCandidate.collectionId != null) {
                pendingSnaps.push({
                    span: span,
                    collectionId: collectionCandidate.collectionId
                });
            }
        });
        pendingSnaps.forEach(function (data) {
            // Create an editable state for the source collection
            if (!_this.getEditCtrlByRevision(data.span.field.collection.revision)) {
                _this.createEditControllerForCollection(data.span.field.collection);
            }
            // Snap the span to the new collection
            data.span.field.Mutator.collection(data.collectionId);
            // Refresh the map drawing for the source collection
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(data.span.field.collection.revision);
        });
    };
    /**
     * Recalculate distance and bearing from non collection linked spans
     */
    TopologicalEditorController.prototype.updateSpansDistanceBearing = function (revision) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var vectors, source;
            return tslib_1.__generator(this, function (_a) {
                vectors = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionVectors(revision);
                source = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionLocation(revision);
                // update spans distance & bearing that are not collection links
                vectors.filter(function (vector) { return !vector.field.isCollectionLink() && core_shared_1.FormModelFieldSubForm.isSpanType(vector.field.parent); }).map(function (vector) {
                    var updatedVector = core_shared_1.IkeGeodesic.getVector(source, vector.target);
                    vector.field.Mutator.manual(updatedVector);
                });
                point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(revision);
                return [2 /*return*/];
            });
        });
    };
    TopologicalEditorController.prototype.bindReactions = function () {
        this.reactionToSelectedCaptureId();
        this.reactionToSelectedCollectionRevision();
    };
    TopologicalEditorController.prototype.reactionToSelectedCaptureId = function () {
        var _this = this;
        this.reaction(function () { return _this.selectedCaptureId; }, function () {
            if (services_1.Services.Map.isReady) {
                _this.map.overlay.setCapture(_this.selectedCapture);
            }
        });
    };
    TopologicalEditorController.prototype.reactionToSelectedCollectionRevision = function () {
        var _this = this;
        this.reaction(function () { return _this.selectedCollectionRevision; }, function () {
            if (_this.selectedCollectionRevision) {
                (0, mobx_1.when)(function () { return !!store_1.AppStore.Collection.get(_this.selectedCollectionRevision); }, function () {
                    if (services_1.Services.Map.isReady) {
                        var collection = store_1.AppStore.Collection.get(_this.selectedCollectionRevision);
                        _this.map.overlay.setCapture(collection.state.getCapture(_this.getCaptureIds()[0]));
                    }
                });
            }
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorController.prototype, "classnames", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorController.prototype, "selectedCollectionRevision", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorController.prototype, "selectedCaptureId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorController.prototype, "selectedVectorId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorController.prototype, "activeTool", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorController.prototype, "collectionEditControllers", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorController.prototype, "isSaving", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorController.prototype, "tag", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorController.prototype, "routeCollectionUUID", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorController.prototype, "tagSummary", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorController.prototype, "collections", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorController.prototype, "collectionModels", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorController.prototype, "mapViewCollections", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorController.prototype, "selectedCollection", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorController.prototype, "selectedCapture", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorController.prototype, "selectedCollectionEdit", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorController.prototype, "hasChanges", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorController.prototype, "setSelectedCollectionRevision", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorController.prototype, "setSelectedCaptureId", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorController.prototype, "setSelectedVectorId", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorController.prototype, "createEditControllerForCollection", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorController.prototype, "contentClassNames", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorController.prototype, "useTool", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorController.prototype, "instantiateTool", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorController.prototype, "exitTool", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorController.prototype, "setSaving", null);
    return TopologicalEditorController;
}(mobx_2.MobxState));
exports.TopologicalEditorController = TopologicalEditorController;
//# sourceMappingURL=topological.editor.ctrl.js.map